import { FileFormat } from '../types';
import type { BundleStructure, DirectoryPrefix, ExportConfig } from '../types';

const updateExportConfigFileStructure = (
    fileFormat: FileFormat,
    exportConfig: ExportConfig,
): BundleStructure & DirectoryPrefix => {
    if ([FileFormat.appleStrings, FileFormat.applePlist, FileFormat.appleXliff].includes(fileFormat)) {
        return {
            androidZipStructure: exportConfig.androidZipStructure,
            webZipStructure: exportConfig.webZipStructure,
            otherZipStructure: exportConfig.otherZipStructure,
            androidDirectoryPrefix: exportConfig.androidDirectoryPrefix,
            arbStructure: exportConfig.arbStructure,
            arbDirectoryPrefix: exportConfig.arbDirectoryPrefix,
            webDirectoryPrefix: exportConfig.webDirectoryPrefix,
            resxStructure: exportConfig.resxStructure,
            resxDirectoryPrefix: exportConfig.resxDirectoryPrefix,
            otherDirectoryPrefix: exportConfig.otherDirectoryPrefix,
            reactNativeStructure: exportConfig.reactNativeStructure,
            reactNativeDirectoryPrefix: exportConfig.reactNativeDirectoryPrefix,
            iosZipStructure: exportConfig.zipStructure,
            iosDirectoryPrefix: exportConfig.directoryPrefix,
        };
    }

    if ([FileFormat.androidSdk, FileFormat.androidResources, FileFormat.javaProperties].includes(fileFormat)) {
        return {
            iosZipStructure: exportConfig.iosZipStructure,
            webZipStructure: exportConfig.webZipStructure,
            otherZipStructure: exportConfig.otherZipStructure,
            iosDirectoryPrefix: exportConfig.iosDirectoryPrefix,
            arbStructure: exportConfig.arbStructure,
            arbDirectoryPrefix: exportConfig.arbDirectoryPrefix,
            webDirectoryPrefix: exportConfig.webDirectoryPrefix,
            resxStructure: exportConfig.resxStructure,
            resxDirectoryPrefix: exportConfig.resxDirectoryPrefix,
            otherDirectoryPrefix: exportConfig.otherDirectoryPrefix,
            reactNativeStructure: exportConfig.reactNativeStructure,
            reactNativeDirectoryPrefix: exportConfig.reactNativeDirectoryPrefix,
            androidZipStructure: exportConfig.zipStructure,
            androidDirectoryPrefix: exportConfig.directoryPrefix,
        };
    }

    if (fileFormat === FileFormat.arb) {
        return {
            iosZipStructure: exportConfig.iosZipStructure,
            androidZipStructure: exportConfig.androidZipStructure,
            webZipStructure: exportConfig.webZipStructure,
            otherZipStructure: exportConfig.otherZipStructure,
            iosDirectoryPrefix: exportConfig.iosDirectoryPrefix,
            androidDirectoryPrefix: exportConfig.androidDirectoryPrefix,
            webDirectoryPrefix: exportConfig.webDirectoryPrefix,
            resxStructure: exportConfig.resxStructure,
            resxDirectoryPrefix: exportConfig.resxDirectoryPrefix,
            otherDirectoryPrefix: exportConfig.otherDirectoryPrefix,
            reactNativeStructure: exportConfig.reactNativeStructure,
            reactNativeDirectoryPrefix: exportConfig.reactNativeDirectoryPrefix,
            arbStructure: exportConfig.zipStructure,
            arbDirectoryPrefix: exportConfig.directoryPrefix,
        };
    }

    if (
        [
            FileFormat.yaml,
            FileFormat.yamlRuby,
            FileFormat.json,
            FileFormat.jsonStructured,
            FileFormat.jsObject,
            FileFormat.gettextPo,
            FileFormat.phpArray,
            FileFormat.phpLaravel,
            FileFormat.phpIni,
            FileFormat.symfonyXliff,
            FileFormat.angularXliff,
            FileFormat.srt,
        ].includes(fileFormat)
    ) {
        return {
            iosZipStructure: exportConfig.iosZipStructure,
            androidZipStructure: exportConfig.androidZipStructure,
            otherZipStructure: exportConfig.otherZipStructure,
            iosDirectoryPrefix: exportConfig.iosDirectoryPrefix,
            androidDirectoryPrefix: exportConfig.androidDirectoryPrefix,
            arbStructure: exportConfig.arbStructure,
            arbDirectoryPrefix: exportConfig.arbDirectoryPrefix,
            resxStructure: exportConfig.resxStructure,
            resxDirectoryPrefix: exportConfig.resxDirectoryPrefix,
            otherDirectoryPrefix: exportConfig.otherDirectoryPrefix,
            reactNativeStructure: exportConfig.reactNativeStructure,
            reactNativeDirectoryPrefix: exportConfig.reactNativeDirectoryPrefix,
            webZipStructure: exportConfig.zipStructure,
            webDirectoryPrefix: exportConfig.directoryPrefix,
        };
    }

    if (FileFormat.resx === fileFormat) {
        return {
            iosZipStructure: exportConfig.iosZipStructure,
            androidZipStructure: exportConfig.androidZipStructure,
            webZipStructure: exportConfig.webZipStructure,
            otherZipStructure: exportConfig.otherZipStructure,
            iosDirectoryPrefix: exportConfig.iosDirectoryPrefix,
            androidDirectoryPrefix: exportConfig.androidDirectoryPrefix,
            arbStructure: exportConfig.arbStructure,
            arbDirectoryPrefix: exportConfig.arbDirectoryPrefix,
            webDirectoryPrefix: exportConfig.webDirectoryPrefix,
            otherDirectoryPrefix: exportConfig.otherDirectoryPrefix,
            reactNativeStructure: exportConfig.reactNativeStructure,
            reactNativeDirectoryPrefix: exportConfig.reactNativeDirectoryPrefix,
            resxStructure: exportConfig.zipStructure,
            resxDirectoryPrefix: exportConfig.directoryPrefix,
        };
    }

    if (
        [
            FileFormat.excel,
            FileFormat.csv,
            FileFormat.resw,
            FileFormat.stf,
            FileFormat.ts,
            FileFormat.html,
            FileFormat.docx,
            FileFormat.pptx,
            FileFormat.idml,
            FileFormat.multilingualExcel,
        ].includes(fileFormat)
    ) {
        return {
            iosZipStructure: exportConfig.iosZipStructure,
            androidZipStructure: exportConfig.androidZipStructure,
            webZipStructure: exportConfig.webZipStructure,
            iosDirectoryPrefix: exportConfig.iosDirectoryPrefix,
            androidDirectoryPrefix: exportConfig.androidDirectoryPrefix,
            arbStructure: exportConfig.arbStructure,
            arbDirectoryPrefix: exportConfig.arbDirectoryPrefix,
            webDirectoryPrefix: exportConfig.webDirectoryPrefix,
            resxStructure: exportConfig.resxStructure,
            resxDirectoryPrefix: exportConfig.resxDirectoryPrefix,
            reactNativeStructure: exportConfig.reactNativeStructure,
            reactNativeDirectoryPrefix: exportConfig.reactNativeDirectoryPrefix,
            otherZipStructure: exportConfig.zipStructure,
            otherDirectoryPrefix: exportConfig.directoryPrefix,
        };
    }

    if (FileFormat.reactNativeJs === fileFormat) {
        return {
            iosZipStructure: exportConfig.iosZipStructure,
            androidZipStructure: exportConfig.androidZipStructure,
            webZipStructure: exportConfig.webZipStructure,
            otherZipStructure: exportConfig.otherZipStructure,
            iosDirectoryPrefix: exportConfig.iosDirectoryPrefix,
            androidDirectoryPrefix: exportConfig.androidDirectoryPrefix,
            arbStructure: exportConfig.arbStructure,
            arbDirectoryPrefix: exportConfig.arbDirectoryPrefix,
            webDirectoryPrefix: exportConfig.webDirectoryPrefix,
            resxStructure: exportConfig.resxStructure,
            resxDirectoryPrefix: exportConfig.resxDirectoryPrefix,
            otherDirectoryPrefix: exportConfig.otherDirectoryPrefix,
            reactNativeStructure: exportConfig.zipStructure,
            reactNativeDirectoryPrefix: exportConfig.directoryPrefix,
        };
    }

    return exportConfig;
};

export default updateExportConfigFileStructure;
